import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { FittingReport2SaveFormDataRequest } from '../models/fitting-report-2';

@Injectable({
  providedIn: 'root'
})
export class FittingReport2DataService {

  constructor(private httpClient: ApiHttpClient) {
  }

  public saveFormData(request: FittingReport2SaveFormDataRequest, cancellationToken: Promise<any>): Promise<string> {

    return this.httpClient.postJsonAsync('FittingReport2/saveFormData', request, cancellationToken);
  }
}
